export const ANSWER_TABS = {
  EXPLANATION: "Explanation",
  REFERENCE: "Reference",
  FURTHER_READING: "Further Reading",
};
